export default __webpack_public_path__ + "static/media/Economics.826d6d2d.svg";